import { RESERVATIONS_SERVICE } from "@/services/reservations.service.js";

const state = {postReservationOutput: false, getReservationsOutput: {}, putReservationOutput: false, deleteReservationByIdOutput: false, getReservationByIdOutput: {}, postReservationEmailOutput: false};

const actions = {
    //Service to create reservations
    postReservation({ dispatch, commit }, input) {
        dispatch('alert/clear', null, { root: true });
        commit('postReservationRequest');

        RESERVATIONS_SERVICE.postReservation(input)
            .then(
                output => {
                    commit('postReservationSuccess', output);
                },
                error => {
                    commit('postReservationFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to get paginated reservations
    getReservations({ dispatch, commit }, queryParams) {
        dispatch('alert/clear', null, { root: true });
        commit('getReservationsRequest');

        RESERVATIONS_SERVICE.getReservations(queryParams)
            .then(
                output => {
                    commit('getReservationsSuccess', output);
                },
                error => {
                    commit('getReservationsFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to update reservations
    putReservation({ dispatch, commit }, input) {
        dispatch('alert/clear', null, { root: true });
        commit('putReservationRequest');

        RESERVATIONS_SERVICE.putReservation(input)
            .then(
                output => {
                    commit('putReservationSuccess', output);
                },
                error => {
                    commit('putReservationFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to remove reservations
    deleteReservationById({ dispatch, commit }, queryParams) {
        dispatch('alert/clear', null, { root: true });
        commit('deleteReservationByIdRequest');

        RESERVATIONS_SERVICE.deleteReservationById(queryParams)
            .then(
                output => {
                    commit('deleteReservationByIdSuccess', output);
                },
                error => {
                    commit('deleteReservationByIdFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to get reservation details
    getReservationById({ dispatch, commit }, queryParams) {
        dispatch('alert/clear', null, { root: true });
        commit('getReservationByIdRequest');

        RESERVATIONS_SERVICE.getReservationById(queryParams)
            .then(
                output => {
                    commit('getReservationByIdSuccess', output);
                },
                error => {
                    commit('getReservationByIdFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to send reservation emails
    postReservationEmail({ dispatch, commit }, input) {
        dispatch('alert/clear', null, { root: true });
        commit('postReservationEmailRequest');

        RESERVATIONS_SERVICE.postReservationEmail(input)
            .then(
                output => {
                    commit('postReservationEmailSuccess', output);
                },
                error => {
                    commit('postReservationEmailFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
};

const mutations = {
    //postReservation
    postReservationRequest(state) {
        state.postReservationOutput = null;
    },
    postReservationSuccess(state, output) {
        state.postReservationOutput = true;
    },
    postReservationFailure(state) {
        state.postReservationOutput = false;
    },

    //getReservations
    getReservationsRequest(state) {
    },
    getReservationsSuccess(state, output) {
        state.getReservationsOutput = output;
    },
    getReservationsFailure(state) {
        state.getReservationsOutput = false;
    },

    //putReservation
    putReservationRequest(state) {
        state.putReservationOutput = null;
    },
    putReservationSuccess(state, output) {
        state.putReservationOutput = true;
    },
    putReservationFailure(state) {
        state.putReservationOutput = false;
    },

    //deleteReservationById
    deleteReservationByIdRequest(state) {
        state.deleteReservationByIdOutput = null;
    },
    deleteReservationByIdSuccess(state, output) {
        state.deleteReservationByIdOutput = true;
    },
    deleteReservationByIdFailure(state) {
        state.deleteReservationByIdOutput = false;
    },

    //getReservationById
    getReservationByIdRequest(state) {
    },
    getReservationByIdSuccess(state, output) {
        state.getReservationByIdOutput = output;
    },
    getReservationByIdFailure(state) {
        state.getReservationByIdOutput = false;
    },

    //postReservationEmail
    postReservationEmailRequest(state) {
        state.postReservationEmailOutput = null;
    },
    postReservationEmailSuccess(state, output) {
        state.postReservationEmailOutput = true;
    },
    postReservationEmailFailure(state) {
        state.postReservationEmailOutput = false;
    },
};

export const reservations = {
    namespaced: true,
    state,
    actions,
    mutations
};